import { useTranslation } from "react-i18next";
import { IOrderActivityLog } from "../../../interfaces";
import {
  formatDateAndTime,
  getFileNameWithoutFolderName,
  getFileSizeInMb,
} from "../../../utils";

/**
 * This component return card by operation create action for activity log
 * @param param0 activity log details
 */
const CreatedLogComponent = ({
  activityLog,
}: {
  activityLog: IOrderActivityLog;
}) => {
  const { t } = useTranslation();
  return (
    <div>
      {!activityLog.field && !activityLog.positionImage ? (
        <div className="card-auto p-24 my-10">
          <div>
            {formatDateAndTime(activityLog.createdAt, "DD.MM.YYYY HH:mm:ss")}
          </div>
          <div>
            {t("order")} <strong>{t("created")}</strong>
          </div>
        </div>
      ) : (
        <div className="card-auto p-24 my-10">
          <div>
            {formatDateAndTime(activityLog.createdAt, "DD.MM.YYYY HH:mm:ss")}
          </div>
          <div>
            {activityLog.updatedBy} <strong>{t("uploaded")}</strong>{" "}
            {t("printdata")}
          </div>
          {activityLog.positionImage && (
            <div className="overflow-wrap-break-word">
              {getFileNameWithoutFolderName(activityLog.positionImage.key)} (
              {activityLog.positionImage.size &&
                getFileSizeInMb(activityLog.positionImage.size)}
              MB)
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CreatedLogComponent;
